import { render } from "./BaseRequiredText.vue?vue&type=template&id=24aefa70"
import script from "./BaseRequiredText.vue?vue&type=script&lang=js"
export * from "./BaseRequiredText.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseRequiredText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24aefa70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24aefa70', __exports__)) {
    console.log('reload')
    api.reload('24aefa70', __exports__)
  }
  
  module.hot.accept("./BaseRequiredText.vue?vue&type=template&id=24aefa70", () => {
    console.log('re-render')
    api.rerender('24aefa70', render)
  })

}


export default __exports__